import React, { useEffect } from 'react'
import { Container, ElementImage, ElementName, Section, SectionElement, SectionElements, SectionTitle, StyledLink } from './style'
import arrow from '../../../assets/home/arrow.svg'
import { applications } from './apps'
import { TypeMainOutlet } from '..'
import { useOutletContext } from 'react-router-dom'

const HomeScreen:React.FC = () => {
  const { setSearch } = useOutletContext<TypeMainOutlet>()
  
  useEffect(() => {
    setSearch('')
  }, [])
  
  return(
    <Container>
      {applications.map((section, index) => (
        <Section key={index}>
          <SectionTitle>{section.nameSection}</SectionTitle>
          <SectionElements>
            {section.apps.map((app, index) => (
              <StyledLink key={index} to={`/panel/${app.path}`}>
                <SectionElement>
                  <ElementImage src={app.image} alt='icon'/>
                  <ElementName>{app.nameApp}</ElementName>
                  <ElementImage className='arrow' src={arrow} alt='arrow-icon'/>
                </SectionElement>
              </StyledLink>
            ))}
          </SectionElements>
        </Section>
      ))}
    </Container>
  )
}

export default HomeScreen